import validator from 'validator'

import confirmations from '../options/confirmations.json'

import {
  normalizeIntValue,
  normalizeStringValue,
} from '../../../../../helpers/normalizers'

export default {
  applicant_name: {
    label: 'Qual seu nome? *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.full_name)
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_email: {
    label: 'Qual seu e-mail? (o mesmo cadastrado no momento da inscrição) *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.email)
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      if (!validator.isEmail(formData[fieldId])) {
        return { [fieldId]: 'invalid' }
      }
      return {}
    },
  },
  applicant_confirmation: {
    label:
      'Vai participar do Hackathon Recode Pro dias 19, 20 e 21 de julho? *',
    initialValue: '',
    options: confirmations,
    parseRegistration(registrationData) {
      return normalizeIntValue(
        registrationData.extra_data.applicant_confirmation,
      )
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
}
